module.exports = __webpack_public_path__ + "static/about-hero-bd3fc2d237b43296f7046bb31aa0e487.jpg";